import proxyRules from "./proxy_rules.js";

type gtagFn = (command: "config" | "get" | "set" | "event" | "consent", ...args: any[]) => void;

class Integration {
	public name:           string | null = null; // E.g. "proquest"
	public getClientToken: () => Promise<string>;
	public gtag:           gtagFn = () => {};

	isIntegration(): boolean {
		return this.name !== null;
	}

	init(name: string, getClientToken: () => Promise<string>, gtag?: gtagFn) {
		this.name = name;
		this.getClientToken = getClientToken;
		if (gtag)
			this.gtag = gtag;
		if (proxyRules[name]) {
			// @ts-ignore
			if (typeof window?.PowerNotes === "undefined") {
				// @ts-ignore
				window.PowerNotes = {};
			}
			// @ts-ignore
			window.PowerNotes.proxyRules = proxyRules[name]();
		}
	}
}

export default new Integration();
